import { render, staticRenderFns } from "./Standapp.vue?vue&type=template&id=08e09583&"
import script from "./Standapp.vue?vue&type=script&lang=js&"
export * from "./Standapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports